import { ApiClient } from "@/api-client/src/core/api-client";
import { AllBrandsResponse, BrandRelatedRespone, TopBrandResponse } from "@/packages/types/brands";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchTopBrands = async (): Promise<TopBrandResponse> => {
  const response = await webService.get<TopBrandResponse>(`/home-brands`);
  return response;
};
export const fetchBrandBySlug = async (
  slug: string
): Promise<BrandRelatedRespone> => {
  const response = await webService.get<BrandRelatedRespone>(`/brands/${slug}`);
  return response;
};

export const fetchAllBrands = async (): Promise<AllBrandsResponse> => {
  const response = await webService.get<AllBrandsResponse>(`/brands`);
  return response;
};
